import React, { useState, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import SectionCard from '../../components/SectionCard';
import InvButton from '../../components/InvButton';
import { InvSelect } from '../../components/InvField';
import StoreConsumptionForm from '../../components/store/StoreConsumptionForm';
import { getStores } from '../../api/stockLedger';
import { toInventoryList } from '../../api/inventory-request';
import { storeDisplayName } from '../../utils/storeEntity';
import useAssignedStoreOptions from '../../hooks/useAssignedStoreOptions';

function resolveConsumptionType(search) {
  const raw = new URLSearchParams(search).get('type');
  return raw === 'PATIENT' ? 'PATIENT' : 'WARD';
}

export default function ConsumptionForm() {
  const history = useHistory();
  const { url } = useRouteMatch();
  const location = useLocation();

  const consumptionType = resolveConsumptionType(location.search);
  const isPatient = consumptionType === 'PATIENT';
  const listUrl = url.replace(/\/consumption\/new$/, '/consumptions');

  const [stores, setStores] = useState([]);
  const [storeId, setStoreId] = useState('');
  const {
    storeLocked, activeStoreId, isStoreScoped, storeOptions,
  } = useAssignedStoreOptions(stores);

  useEffect(() => {
    // API: GET /inventory/stores/
    getStores()
      .then(d => setStores(toInventoryList(d)))
      .catch(() => setStores([]));
  }, []);

  const lockStore = storeLocked && stores.some(s => (s.store_id || s.id) === activeStoreId);

  useEffect(() => {
    if (lockStore) setStoreId(activeStoreId);
    else if (isStoreScoped && activeStoreId && !storeId) setStoreId(activeStoreId);
  }, [lockStore, activeStoreId, isStoreScoped, storeId]);

  const selectedStore = stores.find(s => (s.store_id || s.id) === storeId);
  const storeName = selectedStore ? storeDisplayName(selectedStore) : '';

  function goList() {
    history.push(listUrl);
  }

  if (storeId) {
    return (
      <StoreConsumptionForm
        storeId={storeId}
        storeName={storeName}
        consumptionType={consumptionType}
        onCancel={goList}
        onSuccess={goList}
      />
    );
  }

  return (
    <Box>
      <PageHeader
        eyebrow="Inventory Management"
        title={isPatient ? 'New Patient Consumption' : 'New Ward Consumption'}
        description="Select a store to continue"
        actions={(
          <InvButton variant="outlined" tone="teal" onClick={goList}>
            Cancel
          </InvButton>
        )}
      />
      <SectionCard title="Store">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <InvSelect
              label="Store *"
              value={storeId}
              onChange={e => setStoreId(e.target.value)}
              options={storeOptions}
              disabled={lockStore}
            />
          </Grid>
        </Grid>
      </SectionCard>
    </Box>
  );
}
